import axios from '../axios'
export const save = (data) => {
  // 增
  if (!data.roleId) {
    return axios({
      url: '/api/sys/role/saveSysRole',
      method: 'post',
      data
    })
  } else { // 改
    return axios({
      url: '/api/sys/role/updateSysRole',
      method: 'post',
      data
    })
  }
}
// 修改
export const updateSysRole = (data) => {
  return axios({
    url: '/api/sys/role/updateSysRole',
    method: 'post',
    data
  })
}
// 删除
export const del = (data) => {
  return axios({
    url: '/api/sys/role/deleteSysRoles',
    method: 'post',
    data
  })
}
// 查
export const getSysRolePage = (data) => {
  return axios({
    url: '/api/sys/role/getSysRolePage',
    method: 'post',
    data
  })
}
// 绑定角色和菜单关系
export const bindRoleMenu = (data) => {
  return axios({
    url: '/api/sys/role/bindRoleMenu',
    method: 'post',
    data
  })
}
// 根据角色id查询菜单数组
export const getMenuListIdsByRoleId = (data) => {
  return axios({
    url: '/api/sys/role/getMenuListIdsByRoleId',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/role.js